module.exports = __webpack_public_path__ + "img/de_bg_7.0944b870.jpeg";